<template>
  <div id="content">
    <progressive-img
      id="landing-img"
      src="/images/0010.jpg"
      placeholder="/images/output-10.jpg"
    />
    <p>
      McCarthy Interiors has been making dreams a reality for over 16 years.
      With a specialization in residential design, we bring a unique flair to
      all design needs. From country estates to condos, large budgets or small,
      McCarthy Interiors consistently meets deadlines and creates a beautiful
      result.
    </p>
  </div>
</template>

<script>
  export default {
    name: "Home"
  };
</script>

<style scoped>
  #content {
    padding: 0px 40px 40px 40px;
    text-align: left;
  }

  #landing-img {
    width: 100%;
    max-width: 960px;
    margin: auto;
  }

  p {
    width: 40%;
    margin: auto;
    padding: 20px 0px 0px 0px;
  }
  @media screen and (min-width: 1200px) {
    p {
      width: 50%;
      line-height: 2.5rem;
      font-size: medium;
    }
  }

  @media screen and (min-width: 400px) and (max-width: 1200px) {
    p {
      width: 80%;
      line-height: 2rem;
      font-size: small;
    }
  }

  @media screen and (max-width: 400px) {
    p {
      width: 90%;
      line-height: 1.5rem;
      font-size: x-small;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue